import React, { useState } from 'react'
import {
  ArrowLeft as ArrowLeftIcon,
  ArrowRight as ArrowRightIcon,
  Check as CheckIcon,
  ChevronRight as ChevronRightIcon,
  Edit as EditIcon,
  X as XIcon,
} from 'react-feather'
import {
  Box,
  Button,
  Divider,
  IconButton,
  InputAdornment,
  ListItem,
  ListItemText,
  Paper,
  TextField,
  Typography,
} from '@material-ui/core'
import clsx from 'clsx'

import useStyles from './styles'
import theme from 'theme'

const OPTIONS = [
  'Consentimento do titular',
  'Legítimo interesse do controlador',
  'Execução de contrato ou procedimentos',
  'Cumprimento de obrigação legal',
  'Proteção da vida ou incolumidade',
]

const ChatHITL = () => {
  const classes = useStyles()
  const [selected, setSelected] = useState([])

  const toggleItem = (option) => {
    setSelected((prev) =>
      prev.includes(option)
        ? prev.filter((item) => item !== option)
        : [...prev, option],
    )
  }

  return (
    <Paper>
      <Box
        p={2}
        display="flex"
        gridGap={theme.spacing(2)}
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography variant="h6">
          Quais bases legais sua empresa utiliza para o tratamento de dados
          pessoais?
        </Typography>
        <IconButton size="small">
          <XIcon size={18} />
        </IconButton>
      </Box>
      <Divider />
      <Box>
        {OPTIONS.map((option) => (
          <ListItem
            key={option}
            button
            component="div"
            selected={selected.includes(option)}
            onClick={() => toggleItem(option)}
            className={clsx({
              [classes.selectedItem]: selected.includes(option),
            })}
          >
            <ListItemText>{option}</ListItemText>
            {selected.includes(option) && (
              <Box ml="auto" display="flex" alignItems="center">
                <CheckIcon size={16} />
              </Box>
            )}
          </ListItem>
        ))}
      </Box>
      <Divider />
      <Box>
        <TextField
          size="small"
          fullWidth
          placeholder="Prefiro digitar"
          variant="outlined"
          className={classes.textField}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <EditIcon size={16} />
              </InputAdornment>
            ),
          }}
        />
      </Box>
      <Divider />
      <Box display="flex" justifyContent="space-between" py={1} px={2}>
        <Box display="flex" alignItems="center">
          <IconButton size="small" color="primary">
            <ArrowLeftIcon size={14} />
          </IconButton>
          <Typography variant="body2">1/2</Typography>
          <IconButton size="small" color="primary">
            <ArrowRightIcon size={14} />
          </IconButton>
        </Box>
        <Box display="flex" gridGap={theme.spacing(1)} alignItems="center">
          <Button size="small" variant="text">
            Pular
          </Button>
          <Box>
            <Button
              aria-label="enviar mensagem"
              size="small"
              color="primary"
              variant="contained"
              className={classes.sendIcon}
            >
              <ChevronRightIcon size={18} />
            </Button>
          </Box>
        </Box>
      </Box>
    </Paper>
  )
}

export default ChatHITL
